import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Spin } from 'antd';

import {
  fetchTrainerReflectionSurvey,
  submitTrainerReflection
} from '../../../../actions/trainerReflectionActions';

import Button from '../../../common/Button';

import TrainerSurveyQs from './TrainerSurveyQs';
import {
  isAnswered,
  isQuestionVisible,
  isRequiredQuestion,
  isAutoFilled,
  getAutoFilledAnswer
} from './questionVisibility';
import { Wrapper, IntroText, SubmitError, SuccessMessage } from './style';

class TrainerReflection extends Component {
  state = {
    formState: {},
    submitAttempted: false
  };

  componentDidMount() {
    const {
      sessionDetails,
      existingResponse,
      fetchTrainerReflectionSurvey: fetchSurvey
    } = this.props;

    if (!existingResponse) {
      fetchSurvey(sessionDetails.shortId);
    }
  }

  componentDidUpdate(prevProps) {
    const {
      sessionDetails,
      existingResponse,
      fetchTrainerReflectionSurvey: fetchSurvey
    } = this.props;

    if (prevProps.sessionDetails.shortId !== sessionDetails.shortId) {
      this.setState({ formState: {}, submitAttempted: false });
      if (!existingResponse) {
        fetchSurvey(sessionDetails.shortId);
      }
    }
  }

  handleAnswer = (questionId, value) => {
    this.setState(prev => ({
      formState: {
        ...prev.formState,
        [questionId]: { answer: value }
      }
    }));
  };

  handleSubmit = () => {
    const { formState } = this.state;
    const {
      questions,
      sessionDetails,
      submitting,
      submitTrainerReflection: submit
    } = this.props;

    if (submitting) return;

    this.setState({ submitAttempted: true });

    const visibleQuestions = questions.filter(question =>
      isQuestionVisible(question, questions, formState)
    );

    const missingRequired = visibleQuestions
      .filter(isRequiredQuestion)
      .filter(question => !isAnswered(formState, question._id));

    if (missingRequired.length) return;

    const answeredFormState = {};
    visibleQuestions.forEach(question => {
      if (isAnswered(formState, question._id)) {
        answeredFormState[question._id] = formState[question._id];
      }
    });

    questions.filter(isAutoFilled).forEach(question => {
      answeredFormState[question._id] = {
        answer: getAutoFilledAnswer(question, sessionDetails)
      };
    });

    submit({
      sessionId: sessionDetails._id,
      formState: answeredFormState
    });
  };

  render() {
    const { formState, submitAttempted } = this.state;
    const {
      questions,
      loaded,
      submitting,
      submitted,
      existingResponse,
      submitError
    } = this.props;

    if (submitted || existingResponse) {
      return (
        <Wrapper>
          <SuccessMessage>
            Your feedback has been recorded for this session. Thank you!
          </SuccessMessage>
        </Wrapper>
      );
    }

    if (!loaded) {
      return (
        <Wrapper>
          <Spin />
        </Wrapper>
      );
    }

    const hasMissingRequired = questions
      .filter(question => isQuestionVisible(question, questions, formState))
      .filter(isRequiredQuestion)
      .some(question => !isAnswered(formState, question._id));

    return (
      <Wrapper>
        <IntroText>
          Please take a moment to reflect on this session. Your feedback helps
          us improve the training and support trainers.
        </IntroText>
        <TrainerSurveyQs
          questions={questions}
          answers={formState}
          onAnswer={this.handleAnswer}
          submitAttempted={submitAttempted}
        />
        <Button
          label="Submit"
          onClick={this.handleSubmit}
          loading={submitting}
          disabled={submitting}
        />
        {submitAttempted && hasMissingRequired && (
          <SubmitError>
            Unable to submit form, please correct errors and try again.
          </SubmitError>
        )}
        {submitError && <SubmitError>{submitError}</SubmitError>}
      </Wrapper>
    );
  }
}

const mapStateToProps = state => ({
  questions: state.trainerReflection.questions,
  loaded: state.trainerReflection.loaded,
  submitting: state.trainerReflection.submitting,
  submitted: state.trainerReflection.submitted,
  existingResponse: state.trainerReflection.existingResponse,
  submitError: state.trainerReflection.submitError
});

export default connect(mapStateToProps, {
  fetchTrainerReflectionSurvey,
  submitTrainerReflection
})(TrainerReflection);
